import { GET_837FILES_LIST, REJECT_837_LOCKBOX } from "../../api";
import axiosInstance from "../../axiosInstance";
import { converToStrDateForAPI, converToStrDateTimeForAPI } from "../../components/DashBoard/Dashboard/functions";

export const get837LockBoxList = (page,limit, search ,isExport =false ,header_names) => onResponse => {
    try {
        
        const transformedSearch = Object.fromEntries(
            Object.entries(search || {}).map(([key, value]) => {

                if (key === 'received_date_range') {
                    return [key, converToStrDateTimeForAPI(value)];
                }
                if (key === 'upload_date_range') {
                    return [key, converToStrDateTimeForAPI(value)];
                }
                const arrayProp = ['client','partner']
                if( Array.isArray(value) && arrayProp?.includes(key)){
                     return [key, value?.join(',')]
                }
                if( Array.isArray(value) && key==='status'){
                     return [key, value?.map(i=>i.value)?.join(',')]
                }
                 return [key, value];
            })
        );
        
        axiosInstance.get(GET_837FILES_LIST, {
            params: {
                page,limit,
                ...transformedSearch,
                 ...(isExport && { export_url: true ,header_names:header_names}),
            },
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {
        console.log(error);
        
    }
};

export const reject837LockBox = (id, reject_reason) => onResponse => {
    try {
        axiosInstance.post(REJECT_837_LOCKBOX, { id, reject_reason })
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};